import { render, staticRenderFns } from "./activeDialong.vue?vue&type=template&id=404a268f"
import script from "./activeDialong.vue?vue&type=script&lang=js"
export * from "./activeDialong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports